import { useContext } from 'react';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';

import { PromoteFormDataContext } from '../../../formContext/formData';

type Result = ModelHookResult<{
	displayed: boolean;
}>;

export function useContainer(): Result {
	const {
		data: { promoteShareOnComboExperiment },
	} = usePsfPromoteOrSharePageData();
	const formDataContext = useContext(PromoteFormDataContext);

	return {
		data: {
			displayed:
				(promoteShareOnComboExperiment.variation === 'variant_1' ||
					promoteShareOnComboExperiment.variation === 'variant_2' ||
					promoteShareOnComboExperiment.variation === 'variant_3') &&
				formDataContext !== null,
		},
	};
}
